// sensei-app/client/widgets/RecentGradesWidget.widget.js
export default {
    name: "RecentGradesWidget",
    type: "DataWidget",
    description: "Displays the most recent grades from assessments and assignments.",
    roles: ["student"],
    widget: {
        title: "Recent Grades",
        size: "large",
        dataProvider: {
            main: {
                rpc: "StudentRpc.getRecentGrades"
            }
        },
        viewMode: "list",
        fields: [
            { name: 'topicTitle', label: 'Activity', render: (val) => `<strong>${val}</strong>` },
            { name: 'courseName', label: 'Course' },
            { 
                name: 'score', 
                label: 'Score',
                render: (val, item) => `<span class="badge bg-primary rounded-pill">${val} / ${item.maxScore}</span>`
            }
        ],
        noDataMessage: "No graded activities found."
    }
};